import React from "react";
import Intro from "../../component/Intro";
import Protifile from "../../component/Portfile";
import Footer from "../../component/footer";

function Portfolio({ mode, setmymode }) {
  const textinline5 = {
    headh1: "See",
    spano: "Our projects",
    subh1:
      "Your Digital Solution Partner, We turn ideas into extraordinary digital products.",
    paragraph1:
      "Our projects are crafted with professional expertise to meet our customers' needs, elevate their fields, and utilize technology to enhance productivity.",
  };
  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline5} />
      <Protifile />
      <Footer />
    </div>
  );
}

export default Portfolio;
